import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Image from './components/Image/Image';

const BlogSlideComponent = ({ link, title, image }) => (
  <div
    className={classNames(
      'block float-left w-full flex-[1_1] min-w-[75%] flex-col justify-between items-center max-[767px]:min-w-[75vw] min-h-fit md:min-h-[360px] lg:min-h-[450px] xl:max-h-[375px] mx-2',
      '[&_img]:object-cover [&_img]:block'
    )}
  >
    <Link
      to={link}
      className="block focus-visible:rounded-[5px] focus-visible:mb-[5px] focus-visible:p-[5px] focus-visible:outline-offset-[-2px]"
    >
      <Image alt="" src={image} width={480} height={260} />
      <p className="text-lg font-bold">{title}</p>
    </Link>
  </div>
);

BlogSlideComponent.propTypes = {
  image: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export default BlogSlideComponent;
